import * as React from 'react'; 
import { any, oneOf } from 'prop-types';

export default function ProgressBar({percentage, size}){
   return (
     <div className={`flex bg-gray-400 ${size == 'large' ? 'h-4' : 'h-2'} rounded`}>
       <div style={{width: percentage * 100 + '%'}} className={`rounded ${size == 'large' ? 'h-4' : 'h-2'} bg-red-400`}></div>
     </div>
   )
}

ProgressBar.defaultProps = {
  size: "default" 
}

ProgressBar.propTypes = {
  percentage: any,
  size: oneOf(["default", "large"])
}
